__webpack_require__.p = "/DevOps_Resources_Project/";